import { sendGA4Event } from "../../utils/analytics";
import {
    UserLoggedEvent,
    UserLoggedEventData,
    UserLogoutEvent,
    UserLogoutEventData,
} from "../types";

export const sendEventLogin = () => {
    sendGA4Event({
        event: "user_login",
    });
};

export const sendEventRegister = () => {
    sendGA4Event({
        event: "user_register",
    });
};

export const sendEventLoggedUser = (data: UserLoggedEventData) => {
    window.dispatchEvent(new UserLoggedEvent(data));
    sendGA4Event({
        event: "logged_user",
        event_value: data.uuid,
    });
};

export const sendEventUserLoggedOut = (data: UserLogoutEventData) => {
    window.dispatchEvent(new UserLogoutEvent(data));
    sendGA4Event({
        event: "user_logout",
    });
};
